import Listagem from '../componentes/RelatorioIntencaoVenda/listagem';

function RelatorioIntencaoVenda() {
  return (
    <Listagem></Listagem>
  );
}

export default RelatorioIntencaoVenda;
